import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../../../../shared/modal/modal.service';
import { NavbarService } from '../../../../../shared/navbar/navbar.service';
import { MenuService } from '../../../../../shared/menu/menu.service';
import { AlunosService } from '../../alunos/alunos.service';
import { UserService } from '../../../../../shared/services/user/user.service';
import { LoaderService } from '../../../../../shared/loader/loader.service';
import { ToastService } from '../../../../../shared/toast/toast.service';
import { alunoResponse } from '../../../../../models/alunos.interface';
import { EscolherAlunoComponent } from '../notas/components/escolher-aluno/escolher-aluno.component';
import { StorageServiceService } from '../../../../../shared/storage/storage-service.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-dados-aluno',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './dados-aluno.component.html',
  styleUrl: './dados-aluno.component.scss',
})
export class DadosAlunoComponent implements OnInit {
  documentIdAluno: string = '';
  aluno!: alunoResponse;

  constructor(
    private readonly modalService: ModalService,
    private readonly navbarService: NavbarService,
    private readonly menuService: MenuService,
    private readonly alunoService: AlunosService,
    private readonly usuarioService: UserService,
    private readonly loaderService: LoaderService,
    private readonly toast: ToastService,
    private readonly storageService: StorageServiceService,
  ) {
    navbarService.setTitle('Dados do Aluno');
    menuService.setSelected({
      icon: 'tab',
      label: 'Dados do Aluno',
      route: '/admin/dados-aluno',
      checked: true,
    });

    this.alunoService.alunoSelecionado.subscribe((value) => {
      if (value === null) {
        this.documentIdAluno = this.storageService.obterAluno()?.documentId as string;
        console.log(this.storageService.obterAluno())
      } else {
        this.documentIdAluno = value?.documentId;
      }
    });
    this.buscarAlunoPorId();
  }

  ngOnInit(): void {}

  buscarAlunoPorId() {
    this.loaderService
      .executeWithLoader(
        this.alunoService.buscarAlunoPorId(this.documentIdAluno),
      )
      .subscribe({
        next: (value) => {
          this.aluno = value.data;
        },
        error: (error) => {
          this.toast.notify({
            message: 'Tente novamente !',
            type: 'INFO',
          });
        },
      });
  }
}
